import api from "./api";



export const getSalesReportData = async (outlet_id, date_filter) => {
  const params = {};
  if (outlet_id && outlet_id !== "all") {
    params.outlet_id = outlet_id;
  }
  if (date_filter && date_filter !== "all") {
    // Check if it's a custom date range (format: custom:start_date:end_date)
    if (date_filter.startsWith('custom:')) {
      const [, startDate, endDate] = date_filter.split(':');
      params.from_date = startDate;
      params.to_date = endDate;
    } else {
      // For other timeframes (today, yesterday, last_7_days)
      params.date_filter = date_filter;
    }
  }


  try {
    const response = await api.get('/report/sales', { params })
    return response.data
  }
  catch (error) {
    throw new Error(error?.response?.data?.detail)
  }
}

export const getOrdersReportData = async (outlet_id, date_filter, orderType, status, page = 1, limit = 10) => {
  const params = {
    page: page,
    limit: limit
  };

  if (outlet_id && outlet_id !== "all") {
    params.outlet_id = outlet_id;
  }

  if (orderType && orderType !== "all") {
    params.type = orderType
  }
  if (status && status !== "all") {
    params.status = status
  }

  if (date_filter && date_filter !== "all") {

    if (date_filter.startsWith('custom:')) {
      const [, startDate, endDate] = date_filter.split(':');
      params.from_date = startDate;
      params.to_date = endDate;
    } else {

      params.date_filter = date_filter;
    }
  }

  try {
    const response = await api.get('/report/orders', { params });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.detail || 'Failed to fetch orders report');
  }
};


export const getMenuPerformanceData = async (selectedOutlet = null, startDate = null, endDate = null, category_id,sort_by,sort_order) => {
  const params = {}
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet
  }

  if (startDate && startDate !== '') {
    params.start_date = startDate
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate
  }
  if (category_id && category_id !== 'all') {
    params.category_id = category_id
  }
  if(sort_by){
    params.sort_by = sort_by
  }
  if(sort_order){
    params.sort_order = sort_order
  }

  try {
    const response = await api.get('/menu_report/get_menu_performance', { params });
    // console.log("Respnse of Menu Items => ", response)
    return response.data;
  }
  catch (error) {
    throw new Error(error)
  }
}


export const getGSTReportDataDetailView = async (outlet_id, start_date, end_date, page, limit, order_type) => {
  let params = {}
  if (outlet_id && outlet_id !== 'all') {
    params.outlet_id = outlet_id
  }
  if (start_date) {
    params.start_date = start_date
  }
  if (end_date) {
    params.end_date = end_date
  }
  if (page === 0) params.page = 1
  else params.page = page
  params.limit = limit

  if (order_type && order_type !== 'all') {
    params.type = order_type
  }

  try {
    const response = await api.get('/gst_report/detail_view', { params })
    // console.log("Response => ", response)
    return response.data
  }
  catch (error) {
    throw new Error(error)
  }
}

export const getGSTReportDataSummaryView = async (outlet_id, start_date, end_date) => {
  let params = {}
  if (outlet_id && outlet_id !== 'all') {
    params.outlet_id = outlet_id
  }
  if (start_date) {
    params.start_date = start_date
  }
  if (end_date) {
    params.end_date = end_date
  }
  // if (page === 0) params.page = 1
  // else params.page = page
  // params.limit = limit

  try {
    const response = await api.get('/gst_report/summary_view', { params })
    // console.log("Response => ", response)
    return response.data
  }
  catch (error) {
    throw new Error(error)
  }
}


export const getPeakHoursData = async (params) => {
  try {
    const response = await api.get('/peak_hour_report/', { params })
    return response.data.data
  }
  catch (error) {
    console.error(error)
  }
}

export const getPeakHoursOrdersData = async (params) => {
  const response = await api.get('/peak_hour_report/orders_report', { params });
  return response.data;
};



export const downloadSalesReportPDF = async (outlet_id, date_filter) => {
  // console.log("Params at Sales Report Download", outlet_id)
  const params = {};
  if (outlet_id && outlet_id !== "all") {
    params.outlet_id = outlet_id;
  }
  if (date_filter && date_filter !== "all") {
    // Check if it's a custom date range (format: custom:start_date:end_date)
    if (date_filter.startsWith('custom:')) {
      const [, startDate, endDate] = date_filter.split(':');
      params.from_date = startDate;
      params.to_date = endDate;
    } else {
      // For other timeframes (today, yesterday, last_7_days)
      params.date_filter = date_filter;
    }
  }
  try {
    const response = await api.get(
      'download/report/sales/',
      {
        responseType: "blob",
        params: params
      }
    );

    // Extract filename from Content-Disposition header
    let filename = "sales_report.pdf"; // Default fallback
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);

      if (matches != null && matches[1]) {
        // Remove quotes if present
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    // const originalTitle = document.title;
    // document.title = "Sales Report";

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement("a");
    link.href = fileURL;
    link.download = filename; // Use extracted filename
    document.body.appendChild(link);

    link.click();

    link.remove();
    window.URL.revokeObjectURL(fileURL);
  } catch (error) {
    console.error("Error downloading sales report PDF:", error);
    // You might want to show a user-friendly error message here
    throw error?.response?.status;
  }
};


export const downloadOrdersReportPDF = async (outlet, date_filter, orderType, status) => {
  try {
    const params = {};
    if (outlet) params.outlet_id = outlet;
    if (date_filter && date_filter !== "all") {

      if (date_filter.startsWith('custom:')) {
        const [, startDate, endDate] = date_filter.split(':');
        params.from_date = startDate;
        params.to_date = endDate;
      } else {

        params.date_filter = date_filter;
      }
    }

    if (orderType && orderType !== "all") {
      params.type = orderType
    }
    if (status && status !== "all") {
      params.status = status
    }

    const response = await api.get(
      'download/report/orders/',
      {
        responseType: "blob",
        params: params
      }
    );

    // Extract filename from Content-Disposition header
    let filename = "orders_report.pdf"; // Default fallback
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);

      if (matches != null && matches[1]) {
        // Remove quotes if present
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement("a");
    link.href = fileURL;
    link.download = filename; // Use extracted filename
    document.body.appendChild(link);

    link.click();

    link.remove();
    window.URL.revokeObjectURL(fileURL);
  } catch (error) {
    console.error("Error downloading sales report PDF:", error);
    // You might want to show a user-friendly error message here
    throw error; // Re-throw if you want to handle it elsewhere
  }
};


const getTimeString = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${hours}${minutes}${seconds}`;
};


export const downloadExcelGetMenuPerformanceData = async (selectedOutlet = null, startDate = null, endDate = null, category_id,sort_by,sort_order) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }
  if (category_id && category_id !== 'all') {
    params.category_id = category_id
  }
  if(sort_by){
    params.sort_by = sort_by
  }
  if(sort_order){
    params.sort_order = sort_order
  }


  try {
    const response = await api.get('/menu_report/download/excel/get_menu_performance', {
      params,
      responseType: 'blob'  // Important: This tells axios to handle the response as binary data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `menu_performance_report_${getTimeString()}.xlsx`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading Excel report:", error);
    throw new Error(error.response?.data?.detail || error.message || "Download failed");
  }
};



export const downloadPDFGetMenuPerformanceData = async (selectedOutlet = null, startDate = null, endDate = null, category_id,sort_by,sort_order) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }
  if (category_id && category_id !== 'all') {
    params.category_id = category_id
  }
  if(sort_by){
    params.sort_by = sort_by
  }
  if(sort_order){
    params.sort_order = sort_order
  }


  try {
    const response = await api.get('/menu_report/download/pdf/get_menu_performance', {
      params,
      responseType: 'blob'  // Important: Handle binary PDF data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `menu_performance_report_${getTimeString()}.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading PDF report:", error);
    throw new Error(error.response?.data?.detail || error.message || "PDF download failed");
  }
};


export const downloadExcelSheetGSTReportDetailData = async (selectedOutlet = null, startDate = null, endDate = null, order_type = null) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }
  if (order_type && order_type !== 'all') {
    params.type = order_type
  }

  try {
    const response = await api.get('/gst_report/download/excel/gst_report', {
      params,
      responseType: 'blob'  // Important: This tells axios to handle the response as binary data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `GST_Detail_Report_${getTimeString()}.xlsx`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading Excel report:", error);
    throw new Error(error.response?.data?.detail || error.message || "Download failed");
  }
};



export const downloadExcelSheetGSTReportSummaryData = async (selectedOutlet = null, startDate = null, endDate = null, order_type = null) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }
  if (order_type && order_type !== 'all') {
    params.type = order_type
  }

  try {
    const response = await api.get('/gst_report/download/excel/summary_view', {
      params,
      responseType: 'blob'  // Important: This tells axios to handle the response as binary data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `GST_Detail_Report_${getTimeString()}.xlsx`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading Excel report:", error);
    throw new Error(error.response?.data?.detail || error.message || "Download failed");
  }
};






export const downloadExcelPeakHoursOrders = async (outletId, selectedOrderType, startDate, endDate, startTimeIndex, endTimeIndex, singleDate) => {
  let params = {}
  if (outletId && outletId !== 'all') {
    params.outlet_id = outletId;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }

  params.start_time_index = startTimeIndex
  params.end_time_index = endTimeIndex

  if (selectedOrderType && selectedOrderType !== "all") {
    params.order_type = selectedOrderType
  }

  if (singleDate && startDate === '' && endDate === '') {
    params.single_date = singleDate
  }

  const response = await api.get('/peak_hour_report/orders_report/excel', {
    params,
    responseType: 'blob'
  });
  // Handle file download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'peak_hours_orders_report.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
};



export const downloadPDFGetGSTReportDetailReport = async (selectedOutlet = null, startDate = null, endDate = null, order_type = null, singleDate) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }

  if (order_type && order_type !== 'all') {
    params.type = order_type
  }
  if (singleDate) {
    params.single_date = singleDate
  }

  try {
    const response = await api.get('/gst_report/download/pdf/gst_report', {
      params,
      responseType: 'blob'  // Important: Handle binary PDF data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `gst_report_${getTimeString()}.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading PDF report:", error);
    throw new Error(error.response?.data?.detail || error.message || "PDF download failed");
  }
};



export const downloadPDFGetGSTReportSummaryReport = async (selectedOutlet = null, startDate = null, endDate = null, order_type = null, singleDate) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }

  if (order_type && order_type !== 'all') {
    params.type = order_type
  }
  if (singleDate) {
    params.single_date = singleDate
  }

  try {
    const response = await api.get('/gst_report/download/pdf/summary_view', {
      params,
      responseType: 'blob'  // Important: Handle binary PDF data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `gst_report_${getTimeString()}.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading PDF report:", error);
    throw new Error(error.response?.data?.detail || error.message || "PDF download failed");
  }
};






export const downloadExcelGetPeakHoursItems = async (selectedOutlet = null, startDate = null, endDate = null, category_id, view_type, startTimeIndex, endTimeIndex,date_filter) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }
  if(date_filter && date_filter !== 'all') params.date_filter = date_filter
  if (category_id && category_id !== 'all') params.category_id = category_id
  params.view_type = view_type
  params.start_time_index = startTimeIndex;
  params.end_time_index = endTimeIndex;

  try {
    const response = await api.get('/peak_hour_report/download/excel/peak_hour_item_report', {
      params,
      responseType: 'blob'  // Important: This tells axios to handle the response as binary data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `peak_hours_report_items_${getTimeString()}.xlsx`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading Excel report:", error);
    throw new Error(error.response?.data?.detail || error.message || "Download failed");
  }
};



export const downloadPDFGetPeakHoursItemsReport = async (selectedOutlet = null, startDate = null, endDate = null, category_id = null, view_type, start_time_index, end_time_index,date_filter) => {
  const params = {};
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }
  if(date_filter && date_filter !== 'all') params.date_filter = date_filter
  if (category_id && category_id !== 'all') params.category_id = category_id
  params.view_type = view_type
  params.start_time_index = start_time_index;
  params.end_time_index = end_time_index;





  try {
    const response = await api.get('/peak_hour_report/download/pdf/peak_hours_item_report', {
      params,
      responseType: 'blob'  // Important: Handle binary PDF data
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from Content-Disposition header or create default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `peak_hour_items_report_${getTimeString()}.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error downloading PDF report:", error);
    throw new Error(error.response?.data?.detail || error.message || "PDF download failed");
  }
};




export const downloadPDFPeakHoursOrders = async (outletId, selectedOrderType, startDate, endDate, startTimeIndex, endTimeIndex,singleDate) => {
  let params = {}
  if (outletId && outletId !== 'all') {
    params.outlet_id = outletId;
  }
  if (startDate && startDate !== '') {
    params.start_date = startDate;
  }
  if (endDate && endDate !== '') {
    params.end_date = endDate;
  }

  if (selectedOrderType && selectedOrderType !== "all") {
    params.order_type = selectedOrderType
  }

  params.start_time_index = startTimeIndex
  params.end_time_index = endTimeIndex
  
    if (singleDate && startDate === '' && endDate === '') {
    params.single_date = singleDate
  }
  
  const response = await api.get('peak_hour_report/orders_report/pdf', {
    params,
    responseType: 'blob'
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'peak_hours_orders_report.pdf');
  document.body.appendChild(link);
  link.click();
  link.remove();
};



export const getOutletTimings = async (selectedOutlet) => {
  const params = {}
  if (selectedOutlet && selectedOutlet !== 'all') {
    params.outlet_id = selectedOutlet
  }

  try {
    const response = await api.get('peak_hour_report/get_outlet_time_for_report/', { params });
    // console.log("Respnse of Menu Items => ", response)
    return response.data;
  }
  catch (error) {
    throw new Error(error)
  }
}





